import { render } from "./AccountValid.vue?vue&type=template&id=3d694748"
import script from "./AccountValid.vue?vue&type=script&lang=js"
export * from "./AccountValid.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__